import { MinusCircleOutlined } from '@ant-design/icons';
import { Flex } from '@revenuemarket/cds';
import { Colors, typographyStyle } from '@revenuemarket/design';
import { Typography } from 'antd';

import { CategoryTreeItem } from '~apis/categories';
import HorizontalTreeTable from '~components/ui/HorizontalTreeTable';
import { flattenTree } from '~components/ui/HorizontalTreeTable/Table';

import { TreeTableProps } from './types';

interface Props extends TreeTableProps<CategoryTreeItem> {}

const CategoryLabelTreeTable: React.FC<Props> = ({
  cashFlowType,
  setActiveItem,
  activeItem,
  foldedAll,
  treeData,
}) => {
  return (
    <HorizontalTreeTable<CategoryTreeItem>
      filterCondition={(item) => {
        const filterContra = !item.value?.contraCategoryId;

        const flattenChildren = flattenTree(item.children);

        const childrenHasSameCashFlowType = flattenChildren.some(
          (f) => f.value?.cashFlowType === cashFlowType,
        );

        return item.value.status === 'new'
          ? true
          : (cashFlowType ? childrenHasSameCashFlowType : true) && filterContra;
      }}
      dataHandleCondition={(item) => {
        return (
          !item.value?.contraCategoryId &&
          (cashFlowType ? item.value?.cashFlowType === cashFlowType : true)
        );
      }}
      cellRenderer={(item) => {
        return (
          <Flex>
            <Typography.Text
              ellipsis
              style={{
                color: Colors.gray800,
                ...typographyStyle['13_400'],
                width: item?.value?.isActive === false ? 95 : 120,
              }}
            >
              {item?.value?.label || item?.value?.name}
            </Typography.Text>
            {item?.value?.isActive === false ? (
              <MinusCircleOutlined
                width={18}
                height={18}
                style={{
                  color: Colors.gray400,
                }}
              />
            ) : null}
          </Flex>
        );
      }}
      treeData={treeData}
      foldedAll={foldedAll}
      updatedFocusedId={activeItem?.key}
      onCellClick={(result) => {
        setActiveItem(result);
      }}
      onCellClear={() => {
        setActiveItem(undefined);
      }}
    />
  );
};

export default CategoryLabelTreeTable;
